import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ilo',
    fullName: 'Iloko',
    nativeName: 'Iloko',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid nga",
    landing_title: "Adda Nakaskasdaaw nga Umay",
    landing_subtitle: "Ti ArgVoid ket maysa nga app ken game development studio. Aguraykayo, umay dagiti baro a banag iti mabiit!",
    select_language: "Pilien ti Lenguahe",
    search_placeholder: "Agbirok kadagiti pagsasao...",
    terms_title: "Kondision ti Serbisio",
    policy_title: "Pagannurotan iti Kinapribado",
    cookies_title: "Pagannurotan ti Cookie",
    terms_content: `
        <strong>1. Panangawat kadagiti Kondision</strong><br>
        Babaen ti pananggun-od iti ArgVoid, maawat dagitoy a Kondision ti Serbisio. No saan a napagnunumuan dagitoy a kondision, saan koma nga usaren ti serbisio.<br><br>

        <strong>2. Panagusar ti Plataforma</strong><br>
        Ti ArgVoid ken dagiti aplikasionna ket naited "kas iti kasasaadna" para kadagiti panggep ti impormasion ken panagparnuay. Masapul nga usaren laeng ti serbisio para kadagiti nainkalintegan a panggep.<br><br>

        <strong>3. Maiparit nga Kondukta</strong><br>
        Nainget a maiparit ti pananggundaway kadagiti kinalaka a maapektaran ti site, panag-spam, wenno panangpadas iti di autorisado a panagserrek iti imprastruktura.<br><br>

        <strong>4. Panagkedked ti Panagkedked</strong><br>
        Mabalin a mabaliwan ti plataporma ken serbisio iti aniaman nga oras nga awan ti pakaammo. Awan ti maited a warranty maipapan iti uptime wenno kaadda ti serbisio.
    `,
    policy_content: `
        <strong>1. Koleksion ti Impormasion</strong><br>
        Ti plataporma ket saan a kasapulan ti panagipaneknek ti agar-aramat wenno panagpartuat ti kuenta iti daytoy a panawen. Awan ti personal a pakabigbigan nga impormasion (kas kadagiti nagan wenno email address) nga aktibo a maurnong manipud kadagiti bisita.<br><br>

        <strong>2. Datos ti Panagusar</strong><br>
        Mabalin a maurnong dagiti kangrunaan, di nainaganan nga analitiko tapno maawatan ti trapiko ti site ken mapasayaat dagiti aplikasion. Daytoy a datos ket saan a naisilpo kadagiti indibidual a pakabigbigan ti agar-aramat.<br><br>

        <strong>3. Serbisyo ti Maikatlo a Partido</strong><br>
        Dagiti maikatlo a partido a mangipapaay ket mabalin a mausar para kadagiti serbisio ti panagsangaili ken panaganalisar. Dagiti aramid ti kinapribado dagitoy a bukod a mangipapaay ti mangituray kadagiti di nainaganan a datos a naproseso iti imprastrukturada.<br><br>

        <strong>4. Seguridad ti Datos</strong><br>
        Maipatungpal dagiti nainkalintegan a pamay-an ti seguridad tapno masalakniban ti plataporma. Nupay kasta, awan ti pamay-an ti panagipatulod babaen ti Internet a naan-anay a natalged.<br><br>
    `,
    cookies_content: `
        <strong>1. Ania dagiti Cookies ken Lokal a Pagidulin?</strong><br>
        Dagiti cookies ken ti lokal a pagipempenan ti browser ket dagiti babassit a file ti datos a naidulin iti alikamen tapno malagip dagiti kaykayat ti panagisaad iti ballasiw dagiti panagbisita.<br><br>

        <strong>2. Panggep ti Panagusar</strong><br>
        Ti Browser LocalStorage ket nainget a maus-usar tapno mangidulin kadagiti panagitunos ti panagisaad, a kas ti:<br>
        - Dagiti kaykayat a pagsasao<br>
        - Konfigurasion ti interface ti agar-aramat (e.g., dagiti panagitunos ti layout wenno tema)<br>
        - Temporario nga aplikasion cache<br><br>

        <strong>3. Awan ti Panangsurot</strong><br>
        Saan a mausar dagiti cookies ken lokal a pagipempenan para iti advertising wenno third-party tracking purposes. Amin a naidulin a datos ket nainget para iti kangrunaan a panagandar ti plataporma.<br><br>

        <strong>4. Kontrol</strong><br> nga
        Ti datos ti browser ket mabalin a ma-clear iti ania man nga oras babaen dagiti panagitunos ti browser, a mangi-reset kadagiti ania man a lokal a panagisaad.
    `,
    cookie_consent_text: "Usarenmi dagiti kangrunaan a cookies tapno masigurado nga umiso ti panagandar ti website, kas iti panangtaginayon nga aktibo ti sesionmo, panangidulin iti kaykayatmo a pagsasao, ken dadduma pay a kostumbre a konfigurasion.",
    read_policy: "Basaen ti Pagannurotan ti Cookie",
    support_title: "Kontaken ti Suporta",
    support_subject_label: "Maad",
    support_message_label: "Mensahe",
    support_submit_button: "Mangipatulod iti Mensahe",
    support_hint: "Pakaammo: Daytoy ti manglukat iti default nga aplikasionmo iti email tapno maipatulod ti mensahe.",
    support_success_msg: "Pananglukat ti email app-mo...",
    support_error_msg: "Napaay a nangipatulod iti mensahe. Pangngaasiyo ta padasenyo manen inton agangay.",
    explorer_title: "Explorer",
    history_title: "Pakasaritaan",
    animation_title: "Animasion nga",
    config_title: "Konfigurasion ti",
    tool_mouse: "Pilien ti (Ctrl+M) .",
    tool_brush: "Brush (Ctrl+B) nga .",
    tool_brush_mode: "Modo ti Panagbalbaliw (Solid/Clear) .",
    tool_eraser: "Pagbura (Ctrl+E) .",
    tool_brush_size: "Baliwan ti Kadakkel ti Brush",
    tool_bucket: "Punnuen (Ctrl+F) .",
    tool_eyedropper: "Eyedropper ti mata",
    tool_grid: "Grid (Ctrl + Panagbalbaliw + B) .",
    tool_rotate: "I-rotate (Ctrl + Panagbalbaliw + R) .",
    tool_flip_h: "Flip H (Ctrl + Panagbalbaliw + H) .",
    tool_flip_v: "Flip V (Ctrl + Panagbalbaliw + V) .",
    tool_transpose: "I-transpose (Ctrl + Panagbalbaliw + T) .",
    label_width: "Kaakaba",
    label_height: "Kinatayag",
    label_frames: "Bilang dagiti Kuadro",
    label_animation: "Estilo ti Animasion",
    label_background_color: "Kolor ti Background",
    label_interval: "Interval ti nagbaetan",
    tool_anim_config: "Konfigurasion ti Animasion",
    label_new_width: "Baro a Kalawa",
    label_new_height: "Baro a Kangato",
    label_apply: "Iyaplikar",
    label_colors: "Dagiti kolor",
    label_size: "Kadakkel",
    label_tolerance: "Panagibtur",
    val_horizontal: "Paidda",
    val_vertical: "Patakder",
    val_sequence: "Panagsasaruno",
    val_bounce: "Agkallatik",
    val_random: "Random",
    val_solid: "Natangken",
    val_clear: "Nalawag",
    action_add_sheet: "Baro a Sheet",
    action_import: "Gumatang ti sabali a pagilian",
    action_export: "Iruar ti pagilian",
    action_sort_projects: "Nadumaduma",
    sort_date_old: "Kadaanan Umuna",
    sort_date_new: "Kabarbaro nga Umuna",
    sort_name_az: "Nagan (A-Z) .",
    sort_name_za: "Nagan (Z-A) .",
    action_new_sprite: "Baro nga Sprite",
    action_new_project: "Baro a Proyekto",
    modal_save_all_title: "Idulin ti Amin a Panagbalbaliw",
    modal_save_all_desc: "Pilien dagiti sanikua nga i-save:",
    modal_save_selected: "Idulin ti Napili",
    action_saved: "Naisalakan",
    modal_create_sprite_title: "Mangaramid iti Baro nga Sprite",
    modal_create_project_title: "Mangaramid iti Baro a Proyekto",
    modal_add_sheet_title: "Inayon ti Baro a Panid",
    modal_rename_sheet_title: "Baliwan ti nagan ti Sheet",
    modal_rename_sprite_title: "Baliwan ti nagan ti Sprite",
    modal_delete_sprite_title: "Ikkaten ti Sprite",
    modal_delete_project_title: "Buraken ti Proyekto",
    modal_delete_sheet_title: "Buraken ti Sheet",
    placeholder_sprite_name: "Nagan",
    placeholder_project_name: "Nagan",
    placeholder_sheet_name: "Nagan",
    placeholder_new_name: "Baro a Nagan",
    action_create: "Agaramid",
    action_add: "Agnayon",
    action_rename: "Baliwan ti nagan",
    action_duplicate: "Duplikado",
    action_delete: "Ikkaten",
    action_cancel: "Ikansela",
    confirm_delete_sprite: "Sigurado ka kadi a kayatmo nga i-delete daytoy nga sprite?",
    confirm_delete_project: "Sigurado kadi a kayatmo nga i-delete daytoy a proyekto? Maikkat amin nga sprite.",
    confirm_delete_sheet: "Sigurado kadi a kayatmo nga i-delete daytoy a sheet?",
    err_select_sprite: "Pangngaasiyo ta agpilikayo nga umuna iti sprite.",
    err_select_project: "Pangngaasiyo ta agpilikayo nga umuna iti proyekto.",
    err_name_empty: "Saan a mabalin nga awan ti kargana ti nagan.",
    err_sprite_exists: "Addan ti sprite nga addaan iti dayta a nagan.",
    err_project_exists: "Addan ti proyekto nga addaan iti dayta a nagan.",
    err_no_content: "Awan ti linaon nga i-save.",
    err_no_changes: "Awan dagiti panagbalbaliw nga i-save.",
    err_delete_last_sheet: "Saan a ma-delete ti maudi a sheet.",
    err_extract_frames: "Saan a makaala iti aniaman a kuadro.",
    err_indexeddb: "Napaay nga ag-save iti lokal. Mabalin a saan a suportaran ti browsermo ti IndexedDB.",
    msg_upload_success: "Naballigi ti Panag-upload: {0}",
    msg_upload_failed: "Napaay ti Panag-upload: {0}",
    msg_save_success: "Save naballigi.",
    msg_saving: "Panag-save...",
    msg_multi_save_result: "Naidulin dagiti {0} nga asset. {1} dagiti pannakapaay.",
    menu_title: "Menu ti",
    menu_save: "Ispalen",
    menu_save_all: "Isalakan ti Amin",
    menu_support: "Kontaken ti Suporta",
    label_local_storage: "Lokal a Pagidulin",
    label_sign_in: "Sign In",
    modal_export_title: "I-export ti Sprite",
    label_filename: "Nagan ti file",
    label_format: "Pormat ti",
    action_export_confirm: "Iruar ti pagilian",
};

export default translations;
